import { render, staticRenderFns } from "./industryDetail.vue?vue&type=template&id=636e1148&"
import script from "./industryDetail.vue?vue&type=script&lang=js&"
export * from "./industryDetail.vue?vue&type=script&lang=js&"
import style0 from "./industryDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports